import { TanStackDevtools } from '@tanstack/react-devtools'
import { createRootRoute, Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools'

import { Toaster } from '@/components/ui/sonner'
import { TooltipProvider } from '@/components/ui/tooltip'
import { QueryProvider } from '@/lib/query'
import { useVConsole } from '@/lib/vconsole'

const RootLayout = () => {
  useVConsole()

  return (
    <TooltipProvider>
      <QueryProvider>
        <Outlet />

        <TanStackDevtools
          config={{
            hideUntilHover: true,
            inspectHotkey: ['CtrlOrMeta', 'Shift'],
          }}
          plugins={[
            {
              name: 'Tanstack Router',
              render: <TanStackRouterDevtoolsPanel />,
            },
          ]}
        />

        <Toaster toastOptions={{ className: 'font-sans' }} />
      </QueryProvider>
    </TooltipProvider>
  )
}

export const Route = createRootRoute({ component: RootLayout })
